import { useDispatch, useSelector } from "react-redux";
import { setLearningDataAction } from "../redux/learningData";

const getLearningData = state => state.learningData;

const useLearningData = () => {

  const dispatch = useDispatch();
  const learningData = useSelector( getLearningData );
  const setLearningData = data => { dispatch( setLearningDataAction( data ) ) };

  return {
    learningData,
    setLearningData
  };

};

export default useLearningData;
